// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CollapsiblePanel__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CollapsiblePanel/CollapsiblePanel.scss
 ** module id = 907
 ** module chunks = 1
 **/